export function scrollToAnchor(document: Document, anchor: string) {
  const target = anchor.startsWith('#') ? anchor : `#${anchor}`;
  const element = document.querySelector(target);
  element.scrollIntoView({ behavior: 'smooth' });
}
